import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';
import { getWhitelabelConfig } from 'core/whitelabel';

import { Label, FormWrapper, FormField } from 'libs/forms/styles';
import { TextField } from 'libs/forms/views/fieldTypes/text';
import { PasswordField } from 'libs/forms/views/fieldTypes/password';
import FormActionButton from 'libs/forms/views/formActionButton';
import { Button } from 'components';

import {
  WrapperSignInForm,
  MainSignInFormColumn,
  Footer,
  FooterLabel,
} from 'apps/signIn/styles';

import Heading from 'components/Heading';
import Logo from 'components/Logo';
import { SocialButtons } from 'apps/signIn/views/socialButtons';

import { Spacer } from 'styles/utils';

@withNamespaces()
@observer
export class WhiteLabelForm extends React.Component {
  render() {
    const { form, title, handleSignIn, handleForgotPassword } = this.props;
    const whitelabelConfig = getWhitelabelConfig();
    return (
      <WrapperSignInForm>
        <MainSignInFormColumn>
          <Link name='home'>
            <Logo size='48px' />
          </Link>
          <Spacer size='xxlarge' />

          <Heading level={1} size='large'>
            {title}
          </Heading>
          <SocialButtons />
          <FormWrapper
            posting={form.posting}
            onSubmit={e => {
              e.preventDefault();
              form.prepare();
              handleSignIn();
            }}
            responsive
            maxResponsive
          >
            <FormField>
              <Label>
                <Trans>Username</Trans> or <Trans>email</Trans>
              </Label>
              <TextField
                fieldStore={form.fieldStores.get('usernameEmail')}
                responsive
              />
            </FormField>
            <FormField>
              <Label>
                <Trans>Password</Trans>
              </Label>
              <PasswordField
                fieldStore={form.fieldStores.get('password')}
                responsive
              />
            </FormField>

            <Button
              onClick={handleForgotPassword}
              appearance='plain'
              variant='secondary'
              size='xsmall'
              text={<Trans>Forgot your password?</Trans>}
            />

            <Spacer size='large' />

            <FormActionButton
              formStore={form}
              buttonText='Log in'
              buttonTextPosting={form.conf.buttonTextPosting}
              icon='arrow_right'
              iconPosition='right'
              variant='primary'
            />
          </FormWrapper>
        </MainSignInFormColumn>
        <Footer>
          <FooterLabel>
            <strong>
              {`${
                whitelabelConfig.shortTitle || whitelabelConfig.title
              } is powered by Wikifactory.`}
            </strong>
            &nbsp;Where ideas get made.
          </FooterLabel>
        </Footer>
      </WrapperSignInForm>
    );
  }
}

WhiteLabelForm.propTypes = {
  form: PropTypes.object,
  emoji: PropTypes.string,
  handleSignIn: PropTypes.func,
  handleNoAccount: PropTypes.func,
  handleForgotPassword: PropTypes.func,
  handleRequestInvite: PropTypes.func,
  title: PropTypes.string,
};
